import React from "react";
import Title from "../../ui/Title";

const GenderWithinNoora = () => {
  return (
    <div>
      <Title title="Gender work within Noora Health" className="mb-6" />

      <div className="space-y-4 text-softBlack leading-loose text-base font-normal">
        <p>
          Gender equality has always been a focus area for Noora Health and
          continues to be so in our yearly goals across multiple departments.
          Here are some ways we have been actively changing behaviors around
          gender dynamics :
        </p>
        <div className="space-y-6">
          <div>
            <h3 className="font-semibold text-black mb-2">
              Gender-disaggregated data and policy environment
            </h3>
            <ul className="list-disc list-outside space-y-2 ml-7">
              <li>
                Conducting deep dives into our own data, starting with
                descriptive statistics that categorize our patients, caregivers,
                and remote engagement users, particularly focusing on females.
                This includes analyzing WhatsApp usage and phone ownership to
                understand gendered patterns.
              </li>
              <li>
                Reviewing government policies from a gender lens, particularly
                those that intersect with our work, to ensure our programs
                address gaps or align with these policies.
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-black mb-2">
              Gender-sensitive surveys and studies
            </h3>
            <ul className="list-disc list-outside space-y-2 ml-7">
              <li>
                Incorporating a caregiver and father-specific survey in our
                endline study to gather gender-related data (analysis of these
                surveys is ongoing).
              </li>
              <li>
                Evaluating the impact of our programs on caregiver involvement
                and associated health outcomes from a gender perspective.
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-black mb-2">
              Phone ownership and role modeling
            </h3>
            <ul className="list-disc list-outside space-y-2 ml-7">
              <li>
                Recognizing that phone ownership is gendered, we ensure our
                messaging strategy is not solely directed at mothers but is also
                accessible to other family members who may have the phone and
                can pass information along.
              </li>
              <li>
                Ensuring our curriculum visuals and content showcase men
                supporting maternal and child health behaviors. In the mother
                and child care program (MCH), while advocating for Kangaroo
                mother care (KMC), which is skin-to-skin contact between a
                newborn and an adult, there is an active focus in encouraging
                the father of the child to do so. In most cases, mothers are the
                ones who do it, but we have seen fathers participating as well.
                We aim to present a diverse range of gender roles and
                involvement in caregiving activities.
              </li>
            </ul>
          </div>
          <div>
            <p>
              Other internal initiatives include paternal leave for new fathers
              that spans three months (applies to all new parents including
              fathers, domestic partners, adoptive parents, and parents in
              same-sex couples) and six months if they are the primary
              caregivers, similar to those for a birthing mother.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenderWithinNoora;
